import { DialogContent, DialogTitle, Modal, Paper, Typography, Alert, AlertTitle, DialogActions, Button } from "@mui/material";

const NFeModal = ({ open, onClose }) => {
    const modalOnClose = () => {
        onClose();
    };

    return (
        <>
            <Modal open={open} onClose={modalOnClose} sx={{ height: '100vh', width: '100vw', display: 'flex', overflow: 'auto' }}>
                <Paper
                    elevation={16}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        p: '1rem',
                        borderRadius: '0.25rem',
                        maxWidth: '35.5rem',
                        mx: "auto",
                        my: "auto"
                    }}
                >
                    <DialogTitle
                        sx={{
                            p: '1rem 1.5rem',
                        }}>
                        <Typography variant="h6">
                            Emitir Nota Fiscal de Produto (NF-e)
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{p: 0}}>
                        <Alert severity="info">
                            <AlertTitle>Em desenvolvimento</AlertTitle>
                            Em breve você poderá emitir a Nota Fiscal de Produto (NF-e) para as Peças e Materiais desta cobrança.
                        </Alert>
                    </DialogContent>
                    <DialogActions sx={{ display: 'flex' }}>
                        <Button
                            variant="cancelDialog"
                            color="secondary"
                            onClick={modalOnClose}
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Paper>
            </Modal>
        </>
    )
}

export default NFeModal;